export default "__VITE_ASSET__CfeT58JA__"